
























import Vue from 'vue';
import { f7 } from 'framework7-vue';

import { IActionItem } from '../types';

import config from '../actions.conf.json';
import { appStoreMapper } from '@/store/appstore';
import { actionsStoreMapper } from '../store';
import { showErrorDialog } from '@/misc';
import * as API from '../api';

import NavbarSlotLeft from '@/components/navbar-slot-left.vue';
import ActionsItem from './actions-item.vue';

export default Vue.extend({
  name: 'Actions',
  components: {
    ActionsItem,
    NavbarSlotLeft,
  },
  data: () => ({
    actions: [] as IActionItem[],
    loading: false,
  }),
  computed: {
    asTab(): boolean {
      return this.settings?.tab ?? true;
    },
    ...appStoreMapper.mapState(['currentTab']),
    ...actionsStoreMapper.mapGetters(['settings']),
    ...actionsStoreMapper.mapState(['actionsList']),
  },
  methods: {
    onPTRRefresh(done: () => void) {
      done();

      this.loading = true;
      f7.preloader.show();

      API.getActions()
        .then((response) => {
          this.setActions(response);
        })
        .finally(() => {
          this.loading = false;
          f7.preloader.hide();
        });
    },
    loadActions() {
      this.$f7.preloader.show();
      this.loading = true;

      return this.getActions()
        .catch((error) => {
          showErrorDialog({ error });
        })
        .finally(() => {
          this.$f7.preloader.hide();
          this.loading = false;
        });
    },
    ...actionsStoreMapper.mapActions(['getActions']),
    ...actionsStoreMapper.mapMutations(['setActions']),
  },
  watch: {
    currentTab(value: string) {
      if (value === config.name && !this.actionsList.length) {
        this.loadActions();
      }
    },
  },
});
